import { ApartSideFloatBtn } from '../../../styles/Web/Apart/styled'
import useScroll from '../../../hooks/useScroll.hook'

const ApartSideFloat = () => {
  const scroll = useScroll()
  return <ApartSideFloatBtn onClick={() => scroll.handleTop()} />
}
export default ApartSideFloat
